<template>
    <v-card>
        <v-form
            ref="customerDependantForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col
                            cols="12"
                            justify="start"
                        >
                            <v-btn
                                @click="loadIdentityFindAddForm"
                                class="text-none"
                                color="light-blue darken-1"
                                dark
                                v-if="!customerDependant.dependantIdentityId"
                            >
                                <v-icon
                                    dark
                                    left
                                >mdi-account</v-icon>Specify CustomerDependant
                            </v-btn>
                            <v-btn
                                @click="customerDependant.dependantIdentityId = null"
                                class="text-none"
                                color="light-blue darken-1"
                                text
                                v-else
                            >
                                <v-icon
                                    dark
                                    left
                                >mdi-close</v-icon>Clear CustomerDependant
                            </v-btn>
                            <v-card
                                @click="loadIdentityForm(customerDependant.dependantIdentity)"
                                v-if="customerDependant.dependantIdentityId"
                            >
                                <v-card-text>
                                    {{ customerDependant.dependantIdentity.name }} {{ customerDependant.dependantIdentity.surname }}
                                    <br />
                                    <span v-if="identityTypes">
                                        {{
                                        identityTypes.find(
                                        (x) => x.key == customerDependant.dependantIdentity.identityTypeId
                                        )
                                        ? identityTypes.find(
                                        (x) => x.key == customerDependant.dependantIdentity.identityTypeId
                                        ).value
                                        : ""
                                        }}
                                    </span>
                                    <br />
                                    {{ customerDependant.dependantIdentity.identificationNumber }}
                                </v-card-text>
                            </v-card>
                            <br />
                            <div
                                style="color: red"
                                v-show="customerDependant.dependantIdentityId === 0"
                            >Dependant identity is required</div>
                        </v-col>
                        <v-divider></v-divider>
                        <v-col cols="12">
                            <v-text-field
                                readonly
                                disabled
                                label="Card Number"
                                v-model="customerDependant.cardNumber"
                            ></v-text-field>
                        </v-col>
                        <!--<v-divider></v-divider>
                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                label="Consent Form"
                                placeholder="Set Consent Form"
                                v-model="consentForm"
                            >
                                <template slot="append-outer">
                                    <v-btn
                                        @click.stop="
                      getFile(
                        customerDependant.consentFormFileId,
                        'customerDependant_' +
                          customerDependant.id +
                          '_consentform_' +
                          customerDependant.consentFormFileId
                      )
                    "
                                        elevation="1"
                                        fab
                                        small
                                        v-show="customerDependant.consentFormFileId > 0"
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="!consentFormAvailable"
                        >
                            <div style="color: red">Consent form required.</div>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                label="Application Form"
                                placeholder="Set Application Form"
                                v-model="applicationForm"
                            >
                                <template slot="append-outer">
                                    <v-btn
                                        @click.stop="
                      getFile(
                        customerDependant.applicationFormFileId,
                        'customerDependant_' +
                          customerDependant.id +
                          '_applicationform_' +
                          customerDependant.applicationFormFileId
                      )
                    "
                                        elevation="1"
                                        fab
                                        small
                                        v-show="customerDependant.applicationFormFileId > 0"
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="!applicationFormAvailable"
                        >
                            <div style="color: red">Application form required.</div>
                        </v-col>-->
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(100)]"
                                label="Emergency Contact Number"
                                v-model="customerDependant.emergencyContactNumber"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <br/>
                    <v-row v-if="isUnder18">
                        <v-col cols="12">
                          <h3>Guardian Information</h3>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="customerDependant.guardianName"
                            label="Guardian Name"
                            :rules="isUnder18 ? [requiredRule] : []"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="customerDependant.guardianSurname"
                            label="Guardian Surname"
                            :rules="isUnder18 ? [requiredRule] : []"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="customerDependant.guardianIdentificationNumber"
                            label="Guardian Identification Number"
                            :rules="isUnder18 ? [requiredRule] : []"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    <v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                                v-show="customerDependant.id > 0"
                            >
                                                            <v-col cols="12" >
                                    <v-select
                                        :disabled="isLoading"
                                        :items="consentSmsStatuses"
                                        readonly
                                        item-text="value"
                                        item-value="key"
                                        label="Consent Sms Status"
                                        v-model="customerDependant.consentSms"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                <v-btn
                                    :disabled="(isLoading && !isSendingConsentSms) || customerDependant.consentSms > 0"
                                    :loading="isSendingConsentSms"
                                    @click="sendConsentSms"
                                    class="text-none"
                                    color="secondary darken-1"
                                    >Send Consent Sms</v-btn>
                                </v-col>
                                
                                <v-col  cols="12"
                                md="12"
                                no-gutters>
                            <!-- @@Downloads-->
                            <DependantDownloadsCard :dependantId="customerDependant.id" :identificationNumber="customerDependant.dependantIdentity.identificationNumber"/>
                        </v-col>
                      
                            </v-row>
                            
                    <br/>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="customerDependant.id > 0"
                        >Delete</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{ customerDependant.id > 0 ? "Update" : "Add" }}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-dialog
            persistent
            v-model="identityFindAddFormVisible"
            width="500px"
        >
            <IdentityFindAddForm
                :key="identityFindAddFormKey"
                @close="closeIdentityFindAddForm"
                @located="locatedIdentity"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="identityFormVisible"
            width="500px"
        >
            <IdentityForm
                :hide-delete="true"
                :identity-in="identityFormIdentity"
                :key="identityFormKey"
                @close="closeIdentityForm"
                @saved="updateIdentity"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import IdentityFindAddForm from "./IdentityFindAddForm";
import CustomerDependant from "../../models/CustomerDependant.model";
import Identity from "../../models/Identity.model";
import IdentityForm from "./IdentityForm";
import DependantDownloadsCard from "@/components/widgets/DependantDownloadsCard.vue";

//import EntityType from "../../constants/EntityType.constant";
//import dateToString from "../../helpers/dateToString";

export default {
    mounted: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
                this.consentSmsStatuses = await this.$store.dispatch(
            "customerDependants/getConsentSmsStatuses"
        );
    },


   
       
       
        //
    
    created: function() {},
    props: ["customerDependantIn", "customerId"],
    components: {
        IdentityFindAddForm,
        IdentityForm,
        DependantDownloadsCard
    },

    computed: {

        isUnder18() {
        if (!this.customerDependant.dependantIdentity) return false;

        const idNumber = this.customerDependant.dependantIdentity.identificationNumber;
        if (!idNumber || idNumber.length !== 13) return false;

        const birthDateString = idNumber.substring(0, 6);
        const year = parseInt(birthDateString.substring(0, 2));
        const month = parseInt(birthDateString.substring(2, 4)) - 1;
        const day = parseInt(birthDateString.substring(4, 6));

        let birthDate = new Date(year + 2000, month, day);
        if (birthDate > new Date()) {
            birthDate = new Date(year + 1900, month, day);
        }

        const age = this.calculateAge(birthDate);
        return age < 18;
    },
        applicationFormAvailable: function() {
            if (this.customerDependant.applicationFormFileId > 0) return true;

            if (this.applicationForm) return true;

            return false;
        },
        consentFormAvailable: function() {
            if (this.customerDependant.consentFormFileId > 0) return true;

            if (this.consentForm) return true;

            return false;
        },

   
    },

    data() {
        return {
            consentSmsStatuses: [],
            customerDependant: new CustomerDependant().set(
                this.customerDependantIn
            ),
            identityTypes: [],
            isValid: false,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            identificationNumberRule: v => v && v.length === 13 || "ID number must be 13 characters long",
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",

            identityFindAddFormVisible: false,
            identityFindAddFormKey: 0,
            identityFindAddFormTarget: null,

            customerDependantFormKey: null,
            customerDependantFormVisible: false,
            isSendingConsentSms: false,

            consentForm: null,
            applicationForm: null,

            //identity form
            identityFormVisible: false,
            identityFormKey: 0,
            identityFormIdentity: new Identity()
        };
    },
    methods: {
      
calculateAge(birthDate) {
    try {
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    } catch (error) {
        console.error('Error calculating age:', error);
        return 0; // or some default value
    }
},
                sendConsentSms() {
            this.isSendingConsentSms = true;
            this.isLoading = true;

            this.$store
                .dispatch("customerDependants/sendconsentsms", {customerDependantId: this.customerDependant.id})
                .then(
                    () => {
                        this.notify("Customer dependant consent request sent.", "success");
                        this.customerDependant.consentSms = 1;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //subform handleser --------------------------------------------------------
        loadIdentityFindAddForm() {
            this.identityFindAddFormKey += 1;
            this.identityFindAddFormVisible = true;
        },
        closeIdentityFindAddForm() {
            this.identityFindAddFormVisible = false;
        },
        locatedIdentity(identity) {
            this.customerDependant.dependantIdentityId = identity.id;
            this.customerDependant.dependantIdentity = identity;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedCustomerDependant) {
            this.$emit("saved", savedCustomerDependant);
        },
        emitDeletedEntity(deletedCustomerDependant) {
            this.$emit("deleted", deletedCustomerDependant);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        emitSavedIdentity(savedIdentity) {
            this.$emit("savedIdentity", savedIdentity);
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            //this.isValid = this.$refs.customerDependantForm.validate();

            this.$refs.customerDependantForm.validate();

            if (!(this.customerDependant.dependantIdentityId > 0))
                this.customerDependant.dependantIdentityId = 0;

            return (
                this.isValid &&
                this.customerDependant.dependantIdentityId > 0
                //&& this.consentFormAvailable
                //&& this.applicationFormAvailable
            );
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            console.log('Customer Dependant Data:', this.customerDependant);

            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("ConsentForm", this.consentForm);
                formdata.append("ApplicationForm", this.applicationForm);
                formdata.append(
                    "Model",
                    JSON.stringify(this.customerDependant)
                );

                const parameters = {
                    id: this.customerDependant.id,
                    formData: formdata
                };

                this.$store
                    .dispatch(
                        "customerDependants/" +
                            (this.customerDependant.id == 0
                                ? "create"
                                : "update"),
                        this.customerDependant.id == 0
                            ? parameters.formData
                            : parameters
                    )
                    .then(
                        customerDependantWithInfo => {
                            this.notify(
                                "Customer Dependant successfully saved.",
                                "success"
                            );
                            if (this.customerDependant.id == 0) {
                                this.customerDependant.id =
                                    customerDependantWithInfo.entity.id;
                            }
                            //this.customerDependantIn.customerDependantType = this.customerDependant.customerDependantType;

                            this.consentForm = null;
                            this.applicationForm = null;

                            this.customerDependant.applicationFormFileId =
                                customerDependantWithInfo.entity.applicationFormFileId;
                            this.customerDependant.consentFormFileId =
                                customerDependantWithInfo.entity.consentFormFileId;

                            this.emitSavedEntity(customerDependantWithInfo);

                            this.customerDependant.cardNumber = customerDependantWithInfo.entity.cardNumber; // #86
                            this.customerDependant.consentSms = customerDependantWithInfo.entity.consentSms;
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingConsentSms = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this customerDependant?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch(
                        "customerDependants/delete",
                        this.customerDependant.id
                    )
                    .then(
                        () => {
                            this.notify(
                                "Customer Dependant successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.customerDependant);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },

        //IdentityForm Methods
        loadIdentityForm(identity) {
            this.identityFormIdentity = new Identity().set(identity);
            this.identityFormKey = identity.id;
            this.identityFormVisible = true;
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        },
        updateIdentity(entity) {
            this.customerDependant.dependantIdentity = entity.entity;
            this.emitSavedIdentity(entity);
        }
    }
};
</script>

<style lang="stylus" scoped></style>
